import {
  isWorkflowFormLayoutSupported,
  resolveWorkflowFormLayout,
  type WorkflowFormLayoutField,
} from '@app/shared/workflow-commands/workflow-form-layout';

export const workflowFormWidthChoices = [
  { value: '1x', label: '1x' },
  { value: '2x', label: '2x' },
  { value: '3x', label: '3x' },
  { value: '4x', label: '4x' },
  { value: '5x', label: '5x' },
  { value: 'fill', label: 'Fill available space' },
] as const;

/** Presentation diagnostics over the same strict row resolver used by the renderer. */
export function workflowFormLayoutIssue(
  version: number,
  fields: readonly WorkflowFormLayoutField[],
): string {
  if (resolveWorkflowFormLayout(version, fields)) return '';
  if (
    fields.some(
      (field) => !isWorkflowFormLayoutSupported(version, field.layout),
    )
  )
    return 'This field layout is unavailable in the saved form version.';
  if (fields[0]?.layout?.row === 'previous')
    return 'The first field must start a new row.';
  return 'This field layout is invalid. Review the width and row placement.';
}
